import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths, ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';

import MutationKeys from './keys';

type ArchiveSegmentInput = {
    id: number;
};

const useArchiveSegment = (mutateOptions?: UseMutationOptions<unknown, Error, ArchiveSegmentInput>) =>
    useMutation<ArchiveSegmentInput>(
        MutationKeys.ARCHIVE_SEGMENT,
        CuredApiPaths.SEGMENTS_ARCHIVE,
        mutateOptions,
        ApiMethods.POST
    );

export default useArchiveSegment;
